import Container from '~/components/atoms/Container/Container'

import type { PageNavProps } from '../PageNav/PageNav'
import PageNav from '../PageNav/PageNav'
import ThemeContainer from '../ThemeContainer/ThemeContainer'
import type { ReportTheme } from '../types'

import styles from './InPageNav.module.css'

export interface InPageNavProps {
  items: PageNavProps['items']
  theme: ReportTheme
}

export default function InPageNav({ items = [], theme }: InPageNavProps) {
  return (
    <ThemeContainer theme={theme}>
      <div className={styles.base}>
        <Container>
          <PageNav items={items} isStacked={false} flexWrap />
        </Container>
      </div>
    </ThemeContainer>
  )
}
